import { Stack } from "@mui/joy";
import useOpenThoughtRecord from "hooks/useOpenThoughtRecord";
import LinkV2 from "../../common/LinkV2";

export default function ReferenceLink({
  reference,
  thoughtRecordKey,
}: {
  reference: string;
  thoughtRecordKey?: string;
}) {
  const openThoughtRecord = useOpenThoughtRecord(thoughtRecordKey || "");

  return (
    <Stack direction="row" alignItems={"center"}>
      <LinkV2
        text={reference}
        customSx={{
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: "1",
          WebkitBoxOrient: "vertical",
          textAlign: "start",
          fontWeight: 500,
          whiteSpace: "normal",
        }}
        variant={"Footnote"}
        onClick={() => {
          if (thoughtRecordKey) {
            openThoughtRecord();
          }
        }}
      />
      {thoughtRecordKey && (
        <span
          style={{ fontSize: "12px", opacity: 0.7 }}
          className="material-symbols-rounded"
        >
          north_east
        </span>
      )}
    </Stack>
  );
}
